export default __webpack_public_path__ + "static/media/Michael_Jackson_0006.45ecce4e.jpg";